import { motion } from "framer-motion";

// Reusable section: big title + text on one side, image on the other.
export const Section = ({ id, eyebrow, title, image, reverse = false, tint = "bg-white", children }) => {
  return (
    <section id={id} data-testid={`${id}-section`} className={`py-20 sm:py-28 scroll-mt-24 ${tint}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid lg:grid-cols-2 gap-12 lg:gap-16 items-center ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
          >
            {eyebrow && (
              <p className="text-sm font-800 uppercase tracking-[0.2em] text-rose-500">{eyebrow}</p>
            )}
            <h2 className="mt-2 font-heading text-3xl sm:text-4xl md:text-5xl font-700 text-slate-800">
              {title}
            </h2>
            <div className="mt-6 space-y-4 text-slate-600 font-600 leading-relaxed text-base sm:text-lg">
              {children}
            </div>
          </motion.div>

          {image && (
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
            >
              <img
                src={image}
                alt={title}
                className="w-full h-[300px] sm:h-[440px] object-cover rounded-[2rem] shadow-xl"
              />
            </motion.div>
          )}
        </div>
      </div>
    </section>
  );
};
